
export const MANAGE_MACHINE = "Machines Setup"
export const SAVE_MACHINE = "Save Machine"